import React from 'react';

import { DeleteListsButton } from '@vlabs/monokit/features/delete-lists';
import { generatePath, useHistory } from 'react-router-dom';

import { ListDetailsPageHeader } from './list-details-page-header';
import { ListCardsViewer, ListFacesViewer } from './list-details-viewer';
import st from './ListDetailsPageContent.module.sass';
import { routes } from '@vlapps/point/src/app/routes';
import { ListGeneralInfo } from '../list-general-info';
import { useListTypeContext } from '../ListTypeContext';
import { useListIdFromLocation } from '../useListIdFromLocation';

export function ListDetailsPageContent(): React.JSX.Element {
  const listId = useListIdFromLocation();
  const { listType } = useListTypeContext();
  const history = useHistory();

  return (
    <React.Fragment>
      <ListDetailsPageHeader listId={listId} />
      <div className={st.Main}>
        <div className={st.Sidebar}>
          <div className={st.InfoWrapper}>
            <ListGeneralInfo listId={listId} />
          </div>
          <div className={st.ActionWrapper}>
            <DeleteListsButton
              listIds={[listId]}
              onDeleteLists={() => history.push(generatePath(routes.cardsAndLists.activeTab, { activeTab: 'lists' }))}
            />
          </div>
        </div>
        {listType === 'cards' && (<ListCardsViewer listId={listId} />)}
        {listType === 'faces' && (<ListFacesViewer listId={listId} />)}
      </div>
    </React.Fragment>
  );
}
